import http from '@/common/utils/http-common';
import { UpdateEmployeeMyGroup } from '@/types/EmployeeMyGroup.type';

export type CreateEmployeeMyGroup = {
  employees: Array<number>;
};

class EmployeeMyGroupService {
  create(data: CreateEmployeeMyGroup, id: any) {
    return http.post(`/employee-my-groups/${id}`, data);
  }

  update(data: { employeeMyGroups: Array<UpdateEmployeeMyGroup> }, id: any) {
    return http.put(`/employee-my-groups/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/employee-my-groups/${id}`);
  }
}

export default new EmployeeMyGroupService();
